<script>
	import { Button, Col, Row } from "sveltestrap";
	import PageHeader from "../../../../components/PageHeader/PageHeader.svelte";
	import { form, field } from "svelte-forms";
	import { navigate } from "svelte-routing";
	import {
		loading,
		efficiencyEditData,
		masterData,
		errorMessage,
	} from "../../../../store/store";
	import client from "../../../../services/client";
	import Loader from "../../../../components/Loader/Loader.svelte";
	import { required } from "svelte-forms/validators";
	import { extractErrorMessage } from "../../../../utils/misc";
	import ErrorMessageHandler from "../../../../components/ErrorMessageHandler/ErrorMessageHandler.svelte";
	import { onDestroy } from "svelte";
	import CustomSelect from "../../../../components/CustomSelect/CustomSelect.svelte";
	import CustomInput from "../../../../components/CustomInput/CustomInput.svelte";

	let idMake = window.location.pathname.split(
		"master-data/vehicle-data/vehicle-efficiency/edit/"
	)[1];

	$: fuelName = $masterData.fuelTypes.find(
		(x) => x.id === $efficiencyEditData.vehicleFuelId
	)
		? $masterData.fuelTypes.find(
				(x) => x.id === $efficiencyEditData.vehicleFuelId
		  ).name
		: "";

	let efficiencyError;
	let maxDistanceError;

	const carModel = field("carModel", $efficiencyEditData.vehicleModelId, [
		required(),
	]);
	const carMake = field("carMake", $efficiencyEditData.vehicleMakeId, [
		required(),
	]);
	const fuelType = field("fuelType", $efficiencyEditData.vehicleFuelId, [
		required(),
	]);
	const evMaxDistanceKm = field(
		"evMaxDistanceKm",
		$efficiencyEditData.evMaxDistanceKm,
		[required()]
	);
	const efficiency = field("efficiency", $efficiencyEditData.efficiency, [
		required(),
	]);
	const capacity = field("capacity", $efficiencyEditData.capacity, [
		required(),
	]);
	const myForm = form(
		carMake,
		carModel,
		fuelType,
		evMaxDistanceKm,
		efficiency,
		capacity
	);

	let load = false;
	const handleSubmit = async () => {
		// FuelType "Electric": PUT /api/evCharging/v1/efficiencyRate
		// All other FuelType: PUT /api/vehicle/v1/fuel

		let endpoint = {};
		let data = {
			id: idMake,
			vehicleMakeId: $carMake.value,
			vehicleModelId: $carModel.value,
		};

		const electricEndpoint = {
			url: "/v1/efficiencyRate",
			service: "evCharging",
		};

		const fuelEndpoint = {
			url: "/v1/fuel",
			service: "Vehicle",
		};
		if (fuelName === "Electric") {
			endpoint = electricEndpoint;
			data.capacity = $capacity.value;
			data.efficiency = $efficiency.value;
			data.evMaxDistanceKm = $evMaxDistanceKm.value;
			data.vehicleFuelId = $fuelType.value;
		} else {
			endpoint = fuelEndpoint;
			data.fuelTankSize = $capacity.value;
			data.fuelConsumption = $efficiency.value;
			data.fuelTypeId = $fuelType.value;
		}
		try {
			load = true;
			loading.set(true);
			const res = await client(endpoint.url, {
				method: "PUT",
				version: endpoint.service,
				data,
			});

			if (res.status === 200) {
				if (res.data.code === 400) {
					extractErrorMessage(res.data.message);

					document
						.getElementsByClassName("content-container")[0]
						.scrollTo(0, 0);
				} else {
					navigate("/master-data/vehicle-data/vehicle-efficiency");
				}
			}

			load = false;
			loading.set(false);
		} catch (err) {
			extractErrorMessage(err);
			load = false;
			loading.set(false);
		}
	};

	onDestroy(() => {
		efficiencyEditData.set("");
	});
	let err;
	errorMessage.subscribe((value) => {
		err = value;
	});
</script>

<Row>
	<ErrorMessageHandler message={err} />
	<Col xs={6}>
		<Col xs={12}>
			<div>
				<Col className="row d-flex align-items-start mx-0">
					<PageHeader title="Vehicle Efficiency" />
				</Col>
			</div>
		</Col>
		<Col xs={12} class="my-3">
			<div>
				<h5><b>Edit Vehicle Efficiency</b></h5>
			</div>
			<div>
				<p>*Mandatory fields</p>
			</div>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="priority" class="d-block pt-2 mb-2">
						<span> Vehicle Model* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomSelect
						type="text"
						disabled={true}
						options={$masterData.vehicleModels}
						bind:value={$carModel.value}
						error={$myForm.hasError("carModel.required")}
						errorText={$myForm.hasError("carModel.required")
							? "Vehicle model is required"
							: ""}
					/>
				</Col>
			</Row>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="priority" class="d-block pt-2 mb-2">
						<span> Vehicle Make* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomSelect
						options={$masterData.vehicleMakes}
						disabled={true}
						type="text"
						bind:value={$carMake.value}
						error={$myForm.hasError("carMake.required")}
						errorText="Vehicle make is required"
						defaultOption="Select Vehicle Make"
					/>
				</Col>
			</Row>
		</Col>
		<Col>
			<Row>
				<Col>
					<label for="priority" class="d-block pt-2 mb-2">
						<span> Fuel Type* </span>
					</label>
				</Col>
			</Row>
			<Row>
				<Col xs={6}>
					<CustomSelect
						type="text"
						disabled={true}
						options={$masterData.fuelTypes}
						bind:value={$fuelType.value}
						error={$myForm.hasError("fuelType.required")}
						errorText="Fuel type is required"
						defaultOption="Select fuel type"
					/>
				</Col>
			</Row>
		</Col>
		<Row>
			<Col>
				<Row>
					<Col>
						<label for="mobile" class="d-block my-2">
							<span> Fuel (L)/Battery Capacity (kWh)* </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<CustomInput
							type="text"
							bind:value={$capacity.value}
							error={$myForm.hasError("capacity.required")}
							errorText="Fuel (L)/Battery Capacity (kWh) is required"
						/>
					</Col>
				</Row>
			</Col>
			<Col>
				<Row>
					<Col>
						<label for="mobile" class="d-block my-2">
							<span> Fuel/Battery Efficiency (km)* </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={12}>
						<CustomInput
							type="text"
							bind:value={$efficiency.value}
							error={$myForm.hasError("efficiency.required") ||
								efficiencyError}
							errorText={$myForm.hasError("efficiency.required")
								? "Fuel/Battery Efficiency is required"
								: efficiencyError
								? efficiencyError
								: ""}
						/>
					</Col>
				</Row>
			</Col>
		</Row>
		{#if fuelName === "Electric"}
			<Col>
				<Row>
					<Col>
						<label for="mobile" class="d-block my-2">
							<span> EV max. distance (km) </span>
						</label>
					</Col>
				</Row>
				<Row>
					<Col xs={6}>
						<CustomInput
							type="text"
							bind:value={$evMaxDistanceKm.value}
							error={$myForm.hasError(
								"evMaxDistanceKm.required"
							) || maxDistanceError}
							errorText={$myForm.hasError(
								"evMaxDistanceKm.required"
							)
								? "EV max. distance required"
								: maxDistanceError
								? maxDistanceError
								: ""}
						/>
					</Col>
					<Col class="d-flex justify-content-start" xs={6}>
						<div class="mx-4 my-1">
							<Button
								class="themeButton primary px-2"
								block
								disabled={!$myForm.valid ||
									!$carModel.value ||
									!$carMake.value}
								on:click={myForm.validate}
								on:click={() => handleSubmit()}
							>
								{#if load}
									<Loader />
								{:else}
									Add
								{/if}
							</Button>
						</div>
					</Col>
				</Row>
			</Col>
		{:else}
			<Col class="d-flex justify-content-start" xs={6}>
				<div class="mt-4">
					<Button
						class="themeButton primary px-2"
						block
						disabled={!$myForm.valid ||
							!$carModel.value ||
							!$carMake.value}
						on:click={myForm.validate}
						on:click={() => handleSubmit()}
					>
						{#if load}
							<Loader />
						{:else}
							Add
						{/if}
					</Button>
				</div>
			</Col>
		{/if}
	</Col>
</Row>
